import { ThemeProvider } from '@mui/material/styles';
import theme from "assets/jss/MyTheme";
import "assets/scss/material-kit-pro-react.css";
import hist from "history.js";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route, Router, Switch } from "react-router";
import { PersistGate } from "redux-persist/es/integration/react";
import { persistor, store } from "redux/store";
import { LanguageProvider } from './Utils/Translation/LanguageContext';
import Layout from "views/Layout/Layout";
import './i18n.js';

ReactDOM.render(

  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ThemeProvider theme={theme}>
        <LanguageProvider>
          <Router history={hist}>
            <Switch>
              <Route path='*' component={Layout} />
            </Switch>
          </Router>
        </LanguageProvider>
      </ThemeProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
